module.exports = __webpack_public_path__ + "static/img/flow-icon1.b331d3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flow-icon1.png
// module id = g79k
// module chunks = 1